import { PERSONALISATION_CONSENT_COOKIE } from './cookies';

export const writeToLocalStorage = (key: string, value: string, consentCookie = PERSONALISATION_CONSENT_COOKIE): void => {
    try {
        if (getCookie(consentCookie) === '1') {
            localStorage.setItem(key, value);
        } else {
            localStorage.removeItem(key);
        }
    } catch (_e) {
        // do nothing, localStorage and cookies are not available if the user has disabled them
    }
};

export const writeJSONToLocalStorage = <T>(key: string, value: T, consentCookie = PERSONALISATION_CONSENT_COOKIE): void => {
    writeToLocalStorage(key, JSON.stringify(value), consentCookie);
};

export const readFromLocalStorage = (key: string, consentCookie = PERSONALISATION_CONSENT_COOKIE): string | null => {
    try {
        if (getCookie(consentCookie) === '1') {
            return localStorage.getItem(key);
        }
        localStorage.removeItem(key);
        return null;
    } catch (_e) {
        return null; // localStorage and cookies are not available if the user has disabled them
    }
};

export const readJSONFromLocalStorage = <T>(key: string, consentCookie = PERSONALISATION_CONSENT_COOKIE): T | null => {
    const item = readFromLocalStorage(key, consentCookie);
    try {
        if (item && item !== 'undefined') {
            return JSON.parse(item);
        }
    } catch (_e) {} // Ignore JSON parsing errors
    return null;
};

export const removeFromLocalStorage = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch (_e) {
        // do nothing, localStorage and cookies are not available if the user has disabled them
    }
};

const getCookie = (name: string): string | null => {
    if (typeof document === 'undefined') {
        // Ensure code only runs on the client
        return null;
    }

    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(nameEQ)) {
            return decodeURIComponent(cookie.substring(nameEQ.length));
        }
    }

    return null;
};
